import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Role } from '../models/role';
import { TeamRoleDialogComponent } from './dialogs/team-role-dialog/team-role-dialog.component';
import { RoleService } from '../services/role.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component'

@Component({
  selector: 'app-team-role',
  templateUrl: './team-role.component.html',
  styleUrls: ['./team-role.component.scss'],
  entryComponents: [
    TeamRoleDialogComponent
  ]
})
export class TeamRoleComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'name', 'edit', 'delete'];

  constructor(
    private _roleService: RoleService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
) {

    this.loadTeamRoles()
  }

  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadTeamRoles() {

    this.sub = this._roleService.select()
      .subscribe((result) => {

        let array = result.map(item => {
          let entity = new Role();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
         // this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Team Roles Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {


    let data: Role = new Role();

    if (entity) {
      data = entity;
    }

    this.dialog.open(TeamRoleDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir este papel?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._roleService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete papel error: " + error.message) }
          )
      }
    })
  }

}
